
const InstructionCard = ({
  totalPercentage = 0,
  isValid = true,
  subjectLabel = "worker",
  sticky = true,
  dragHint = "Drag documents to reorder or move between categories.",
}) => {
  const percentage = Number(totalPercentage) || 0;
  const getCircleColor = () => {
    if (percentage === 100 && isValid) return "bg-green-500";
    if (percentage > 0 && percentage < 100) return "bg-yellow-500";
    return "bg-red-500";
  };
  const card = (
    <div className="flex items-stretch rounded-xl border border-gray-200 bg-white">
        <div className="flex-1 py-3 pl-6 pr-6 min-w-0">
          <ul className="text-sm text-gray-600 space-y-1.5 list-disc list-inside leading-relaxed">
            <li>
            Please specify the percentage for each <strong>document</strong> and <strong>form</strong> related to {subjectLabel} compliance in the onboarding process.
            </li>
            <li>
              The total percentage must be equal to <strong>100</strong>.
            </li>
            <li>
              {dragHint}
            </li>
          </ul>
        </div>
        <div className="flex-shrink-0 w-px bg-gray-200 self-stretch" />
        <div className="flex flex-col items-center justify-center py-6 pr-6 pl-6 min-w-[120px]">
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
            Compliance Allocation
          </span>
          <div
            className={`w-14 h-14 rounded-full flex items-center justify-center text-white text-base font-semibold mt-2 shadow-sm ${getCircleColor()}`}
          >
            {percentage}%
          </div>
        </div>
    </div>
  );

  if (!sticky) return card;

  return (
    <div className="sticky z-30" style={{ top: "5.5rem" }}>
      {card}
    </div>
  );
};

export default InstructionCard;
